import { useTheme } from 'next-themes'

interface SFTPIconProps {
  size?: number
}

export const SFTPIcon = ({ size = 4 }: SFTPIconProps) => {
  const { theme } = useTheme()
  const sizeInPixels = size * 4
  const wrapperPaddingClass = size <= 4 ? 'p-0.5' : 'p-1'

  return (
    <div
      className={`flex items-center justify-center rounded-md border border-gray-200 ${wrapperPaddingClass} dark:border-gray-700`}
    >
      <img
        className={`h-${size} w-${size}`}
        style={{
          height: `${sizeInPixels}px`,
          width: `${sizeInPixels}px`
        }}
        src={`https://chaine-images.s3.amazonaws.com/product-app-images/app-icons/sftp-${theme === 'dark' ? 'dark' : 'light'}.png`}
        aria-label="tive-icon"
        alt="Tive icon"
      />
    </div>
  )
}
